import React, {useEffect, useImperativeHandle, useState} from "react";
import {fields as fieldsInit} from "./config";
import {Form} from "antd";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import moment from "moment";
import {
  convertIosStringToDate,
  convertIosStringToDate2,
  convertIosStringToDateDayjs,
  formatDateToString,
} from "helper/common";
import {setStoreId} from "redux/reducer/glassKiot";
import {getListStore} from "redux/reducer/glassStore";
import {TT_DON_KINH} from "types/enums";
import {getListPatientAPI} from "redux/reducer/glassKiot";
const PatientInfo = React.forwardRef<any>((props, ref) => {
  const detailBill = useAppSelector(state => state.glassKiot.detailBill);
  const statusBill = useAppSelector(state => state.glassKiot.statusBill);
  const dispatch = useAppDispatch();
  const listStore = useAppSelector(state => state.glassStore.listStore);
  const [fields, setFields] = useState<any[]>(fieldsInit);
  const [form] = Form.useForm();
  const listPatient = useAppSelector(state => state.glassKiot.listPatient);
  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return formatFormValue();
    },
  }));
  const formatFormValue = async () => {
    try {
      const rawValues = await form.validateFields();
      const formatValues = {
        ...rawValues,
        ngaySinh: formatDateToString(rawValues?.ngaySinh, null),
        thoiGianBan: formatDateToString(rawValues?.thoiGianBan, null),
      };
      return formatValues;
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    console.log(detailBill);
    if (detailBill) {
      setFormValue();
    } else {
      form.resetFields();
      form.setFieldValue("status", TT_DON_KINH.CHUA_BAN);
    }
  }, [detailBill]);
  const setOptionsStore = listStore => {
    const options = listStore.map(e => ({
      label: e?.name,
      value: e?.id,
      key: e?.id,
    }));

    fieldsInit.find(e => e.name == "storeId").options = options;
    fieldsInit.find(e => e.name == "storeId").onChange = storeId => {
      dispatch(setStoreId(storeId));
    };
    setFields([...fieldsInit]);
  };
  useEffect(() => {
    dispatch(getListStore());
  }, []);
  const setOptions = listPatient => {
    const options = listPatient.map(e => ({
      label: `${e?.hoTen} ${e?.dienThoai ? `- ${e?.dienThoai}` : ""}`,
      value: e?.id,
      key: e?.id,
    }));

    fields.find(e => e.name == "hoTen").options = options;
    setFields([...fields]);
  };
  useEffect(() => {
    setOptions(listPatient);
    setOnSearch();
  }, [listPatient]);

  // useEffect(() => {
  //   const setOnKeyDown = () => {
  //     fields.find(e => e.name == "hoTen").onKeyDown = e => {
  //       if (e?.key == "Enter") {
  //         console.log(e);
  //         dispatch(getListPatientAPI(e?.target?.defaultValue));
  //       }
  //     };
  //     setFields([...fields]);
  //   };
  //   setOnKeyDown();
  // }, []);
  const setOnSearch = () => {
    fields.find(e => e.name == "hoTen").onSearch = e => {};
    fields.find(e => e.name == "hoTen").onChange = e => {
      setSelectedPatient(e);
    };

    setFields([...fields]);
  };
  const setSelectedPatient = id => {
    const selectedPatient = listPatient.find(
      e => e?.id?.toString() == id?.toString()
    );
    if (selectedPatient && selectedPatient != undefined) {
      form.setFieldValue("hoTen", selectedPatient?.hoTen);
    }

    form.setFieldValue("maBenhNhan", selectedPatient?.id);
    form.setFieldValue("dienThoai", selectedPatient?.dienThoai);
    form.setFieldValue("gioiTinh", selectedPatient?.gioiTinh ?? null);
    form.setFieldValue(
      "ngaySinh",
      convertIosStringToDateDayjs(selectedPatient?.ngaySinh)
    );
    form.setFieldValue("diaChi", selectedPatient?.diaChi);
  };
  useEffect(() => {
    setOptionsStore(listStore);
  }, [listStore]);

  const setFormValue = () => {
    const dto = detailBill.glassesSalesDto;
    form.setFieldsValue({
      ...dto,
      ngaySinh: convertIosStringToDate(dto?.ngaySinh),
      thoiGianBan: convertIosStringToDate2(dto?.thoiGianBan),
      thoiGianTra: convertIosStringToDate2(dto?.thoiGianTra),
    });
  };
  useEffect(() => {
    const disableFields = () => {
      fieldsInit.find(e => e.name == "storeId").disable =
        statusBill != TT_DON_KINH.CHUA_BAN;

      fieldsInit.find(e => e.name == "thoiGianTra").hide =
        statusBill != TT_DON_KINH.HOAN_LAI;
      setFields([...fieldsInit]);
    };

    disableFields();
  }, [statusBill]);
  return (
    <Form form={form} labelAlign="left">
      <PatientInfoCommon
        showHeader={false}
        fields={fields}
        data={{anh: detailBill?.prescriptionDto?.anh}}
      />
    </Form>
  );
});

export default PatientInfo;
